import { createSelector, Selector } from 'reselect'

const getState = (state: any) => state.foodMenu

export const getMenuSelector = createSelector(getState, (menu) => menu.menus)
export const getMenuGroups = createSelector(getState, (menu) => menu.menu_groups)

export const getGroupItems = createSelector(getState, (state) => state.groupItems)